import { itemToAnalyticsItem, useCart } from 'apps/vtex/hooks/useCart.ts'
import Button from './common.tsx'

function CartButton({ isMinicart, size }: { isMinicart?: boolean; size?: 'md' | 'lg' }) {
    const { loading, cart } = useCart()
    const { totalizers = [], items = [], marketingData, storePreferencesData, value } =
        cart.value ?? {}
    const coupon = marketingData?.coupon ?? undefined
    const currency = storePreferencesData?.currencyCode ?? 'BRL'
    const total = totalizers.find((item) => item.id === 'Items')?.value ?? 0
    const discounts = totalizers.find((item) => item.id === 'Discounts')?.value ?? 0

    return (
        <Button
            size={size}
            isMinicart={isMinicart}
            currency={currency}
            loading={loading.value}
            total={value ? value / 100 : (total - discounts) / 100}
            items={items.map((item, index) => itemToAnalyticsItem({ ...item, coupon }, index))}
        />
    )
}

export default CartButton
